'use client';

import {styled} from "@mui/material/styles";
import Button from "@mui/material/Button";

const CategoryButton = styled(Button)({
    padding: ".5rem 1rem",
    display: "inline-block",
    borderRadius: "24px",
    textAlign: "center",
    fontWeight: 700,
    fontSize: "14px",
    whiteSpace: "nowrap",
    width: "auto",
    maxWidth: "100%",
    border: "none",
    color: "#000",
    backgroundColor: "#BFBEBD",
    textTransform: 'none',
});

export default CategoryButton;
